import { SLLayer } from './../model/sl-layer';
import { Injectable } from '@angular/core';

export type FilterLayerId = number;
export type Filter = {
  filterLayer: number;
  filterField: string;
  filterIds: Array<string>;
}

export type Filters = {
  [key: FilterLayerId]: Filter;
};

@Injectable({
  providedIn: 'root'
})
export class FeatureFilterService {

  public filters: Filters = {};

  constructor() { }

  SetFilter(layer: SLLayer, field: string, ids: Array<string>) {
    let needRefresh = false;
    if (ids[0] === '') ids.pop();
    if (field === '' || ids.length == 0) {
      if(field === '') {
        this.UnsetLayerFilter(layer);
      }
      layer.Clear();
      needRefresh = true;

    }
    layer.filterField = field;
    layer.filterIds = ids;
    layer.Touch(true);
    this.filters[Number(layer.identifier)] = { filterLayer: Number(layer.id), filterField: field, filterIds: ids };

    if (needRefresh) {
      layer.Render();
    }
  }
  UnsetLayerFilter(layer: SLLayer) {
    layer.filterField = undefined;
    layer.filterIds = [];
    delete this.filters[layer.identifier];
  }
  ToJSON() {
    return JSON.stringify(this.filters);
  }

}
